import { Divider, Fab, Grid, IconButton, Paper, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, Theme, Typography, withStyles } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import React, { useDispatch, useGlobal } from 'reactn';
import IForfettariAppBar from '../../appBar/IForfettariAppBar';
import Main from '../../components/main';
import '../../css/media-query-styles.css';
import BlockIcon from '@material-ui/icons/Lock'
import RestoreIcon from '@material-ui/icons/Restore'
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import { Applicazioni } from '../../types/types';
import { IGlobalState, InEditingMode } from '../../states/GlobalState';
import { Company, CompanySearchModel } from '../../models/company';
import TablePaginationActions from '../../pagination/TablePaginationActions';
import { useHistory } from 'react-router-dom';
import { getCompanies, getCompany } from '../../services/companyServices';
import { useLogger } from '../../logger';
import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { globalStyles } from '../../style/GlobalStyles';

const useStyles = makeStyles((theme: Theme) => createStyles({
  tableContainer: {
      width: "100%",
      marginTop: theme.spacing(3),
      overflowX: "auto",
  },
  table: {
      minWidth: 700,
  },
  tablerow: {
      cursor: 'pointer',
  },
  filterContainer: {
      paddingLeft: theme.spacing(2),
      paddingBottom: theme.spacing(0),
      display: 'flex',
  },
  fab: {
    textAlign: 'right'
  }
}));

const CustomBlockIcon = withStyles((theme: Theme) => createStyles({
  root: {
      fontSize: 20,
      color: theme.palette.secondary.main,
  },
}))(BlockIcon);
const ExpiredIcon = withStyles((theme: Theme) => createStyles({
  root: {
      fontSize: 20,
      color: theme.palette.primary.light,
  },
}))(RestoreIcon);
const CustomTableCellForIcon = withStyles((theme: Theme) => createStyles({
  body: {
      fontSize: 20,
      textAlign: 'center',
      color: theme.palette.secondary.main,
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingTop: theme.spacing(0.25),
      paddingBottom: theme.spacing(0),
      borderLeft: 'solid 1px #c0c0c0'
  },
}))(TableCell);
const CustomTableCell = withStyles((theme: Theme) => createStyles({
  head: {
      fontSize: 14,
      // backgroundColor: theme.palette.common.black,
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.common.white,
      paddingLeft: theme.spacing(1),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      borderLeft: 'solid 1px #c0c0c0',
  },
  body: {
      fontSize: 14,
      paddingLeft: theme.spacing(1),
      paddingTop: theme.spacing(0.25),
      paddingBottom: theme.spacing(0.25),
      borderLeft: 'solid 1px #c0c0c0'
  },
}))(TableCell);
const CustomTableRow = withStyles((theme: Theme) => createStyles({
  root: {
      color: "inherit",
      display: "table-row",
      outline: "none",
      verticalAlign: "middle",
      height: 28,
  },
}))(TableRow);

export default function CompanyIndex() {
    // eslint-disable-next-line
    const classes = useStyles();
    const gClasses = globalStyles();
    const dispatch = useDispatch();
    const [pagination, setPagination] = useGlobal<IGlobalState, 'companyPagination'>('companyPagination');
    const [filteredCompanies, setFilteredCompanies] = useGlobal<IGlobalState, 'filteredCompanies'>('filteredCompanies');
    const [loadingCompanies, setLoadingCompanies] = useGlobal<IGlobalState, 'loadingCompanies'>('loadingCompanies');
    const [globalWait, setGlobalWait] = useGlobal<IGlobalState, 'globalWait'>('globalWait');
    const [application, setApplication] = useGlobal<IGlobalState, 'application'>('application');
    const [ip, ] = useGlobal<IGlobalState, 'ip'>('ip');
    const [auth, ] = useGlobal<IGlobalState, 'auth'>('auth');
    const history = useHistory();
    const logger = useLogger({key: 'company'});
    let model: CompanySearchModel = new CompanySearchModel();
    
    const _handleChangePage = (ev: React.MouseEvent<HTMLButtonElement> | null, page: number) => setPagination({...pagination, page});
    const _handleChangeRowsPerPage = (ev: React.ChangeEvent<HTMLTextAreaElement|HTMLInputElement>) => setPagination({...pagination, rowsPerPage: parseInt(ev.target.value)})
    
    const _handleRowClick = (ev: React.MouseEvent<HTMLTableRowElement, MouseEvent>, company: Company) => {
        if(globalWait) {return;}
        console.log(`_handleRowClick.${company.Id}`, {company})
        setGlobalWait(true);
        getCompany(ip, auth.authData!, auth.user!, company.Id).then((p: Company)  => {
            if(p) {
                dispatch.setCurrentEditCompanyAndMode(p, 'Edit');
                history.push(`/companyDetail/${company.Id}`);
            } else {
                // notifyUser(`Company con oid = ${company.Id} non trovata`, 'error')
                logger.error('Errore in recupero company non trovata avente id: ' + company.Id);
            }
        }).finally(() => setGlobalWait(false));
    }
  
    const handleAdd = () => {
        console.log('*** +++ handleAdd')
        const newOid = 0;
        // const ownerDefault = adOwnerContext
        // const livelloDefault = adLevels ? adLevels[0].value as number : 0;
        
        //GESTIRE NELLO STATO ma da fare prima ??
        dispatch.createNewCompany(newOid);
        history.push(`/companyDetail/${newOid}`);
    }

    const handleSearch = () => {
        setLoadingCompanies(true);
        // model.BusinessName = "WKI";
        getCompanies(ip, auth.authData!, auth.user!, model).then(res => {
            console.log('Ritorno le company ' + JSON.stringify(res));            
            setFilteredCompanies(res as Company[]);
            // history.push(`/companyDetail/${company.Id}`);
        }).catch(error => {
            logger.error('Errore in recupero company: ' + error.statusText);
        })
        .finally(() => setLoadingCompanies(false));
    }
    
    useEffect(() => {
        setApplication(Applicazioni.Company);
    }, []);
    
    return (
    <div style={{ backgroundColor: "#e3e3e3", minHeight: "100vh" }}>
        <IForfettariAppBar title="Gestione Company" handleLoad={() => {}}></IForfettariAppBar>
        <Main>
            <div className={gClasses.rootModel}>
                <motion.div 
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    transition={{ delay: 0.5, duration: 1.5}}
                    style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
                    {/* <UserLoader /> */}
                    {/* <div style={{ flex: '1 1' }}>&nbsp;</div> */}
                    <div style={{ flex: '0 1' }}>
                        <Fab color='default' size='small' className={classes.fab} onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleAdd()}>
                            <AddIcon titleAccess="Aggiungi company"/>
                        </Fab>
                    </div>
                    &nbsp;
                    <div style={{ flex: '0 1' }}>
                        {/* <Fab color='default' size='small' className={classes.fab} onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleAdd()}><AddIcon /></Fab> */}
                        <Fab color='default' size='small' className={classes.fab} onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleSearch()}>
                            <SearchIcon titleAccess="Ricerca company"/>
                        </Fab>
                    </div>
                </motion.div>
                <Paper className={classes.tableContainer}>
                    <Table className={classes.table} size='small'>
                        <TableHead>
                            <TableRow>
                                <CustomTableCell>&nbsp;</CustomTableCell>
                                <CustomTableCell>Id</CustomTableCell>
                                <CustomTableCell>Nome</CustomTableCell>
                                <CustomTableCell>Codice Fiscale</CustomTableCell>
                                <CustomTableCell>Partita Iva</CustomTableCell>
                                <CustomTableCell>Logo</CustomTableCell>
                                <CustomTableCell>Nome App</CustomTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {!loadingCompanies && filteredCompanies && filteredCompanies.length 
                            ? (filteredCompanies.slice(pagination.page * pagination.rowsPerPage, pagination.page * pagination.rowsPerPage + pagination.rowsPerPage).map(company => (
                                <TableRow hover={true} key={company.Id} onClick={(ev: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => _handleRowClick(ev, company)} className={classes.tablerow}>
                                    <CustomTableCellForIcon>
                                        {company.IsLocked && <CustomBlockIcon titleAccess='Company Bloccata' />}
                                    </CustomTableCellForIcon>
                                    <CustomTableCell>{company.Id}</CustomTableCell>
                                    <CustomTableCell>{company.BusinessName}</CustomTableCell>
                                    <CustomTableCell>{company.TaxCode}</CustomTableCell>
                                    <CustomTableCell>{company.VatNumber}</CustomTableCell>
                                    <CustomTableCell>{company.UiLogoUrl}</CustomTableCell>
                                    <CustomTableCell>{company.ApplicationName}</CustomTableCell>
                                </TableRow>
                            ))) 
                            : <CustomTableRow>
                                <CustomTableCell colSpan={5}>
                                    <Typography variant="h6" color="textSecondary">{loadingCompanies ? "Caricamento..." : "Nessun dato da visualizzare"}</Typography>
                                </CustomTableCell>
                            </CustomTableRow>}
                        </TableBody>
                        <TableFooter>
                            <CustomTableRow>
                                <CustomTableCell colSpan={6}>
                                    <TablePagination
                                        rowsPerPageOptions={[10,20,30]}
                                        count={filteredCompanies ? filteredCompanies.length : 0}
                                        rowsPerPage={pagination.rowsPerPage}
                                        page={pagination.page}
                                        SelectProps={{native: false,}}
                                        onChangePage={_handleChangePage}
                                        onChangeRowsPerPage={_handleChangeRowsPerPage}
                                        ActionsComponent={TablePaginationActions}
                                        labelRowsPerPage="Righe per pagina"
                                        labelDisplayedRows={({ from, to, count }) => count ? `${from}-${to} di ${count}` : ""}
                                        component='div'
                                        style={{display: 'flex'}}
                                    />
                                </CustomTableCell>
                            </CustomTableRow>
                        </TableFooter>
                    </Table>
                </Paper>
            </div>
        </Main>
    </div>
  );
}